import React from 'react'
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  Input,
  NumberInput,
  NumberInputField
} from '@chakra-ui/react'

import { RentalAddOnFormErrors } from './validation'

type RentalAddOnScheduleFieldsProps = {
  amount: string
  endDate: string
  errors: RentalAddOnFormErrors
  isAmountDisabled?: boolean
  isDisabled: boolean
  onAmountChange: (amount: string) => void
  onEndDateChange: (endDate: string) => void
  onStartDateChange: (startDate: string) => void
  showErrors: boolean
  startDate: string
}

export default function RentalAddOnScheduleFields({
  amount,
  endDate,
  errors,
  isAmountDisabled = false,
  isDisabled,
  onAmountChange,
  onEndDateChange,
  onStartDateChange,
  showErrors,
  startDate
}: RentalAddOnScheduleFieldsProps) {
  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, minmax(0, 1fr))' }} gap={4}>
      <FormControl
        isRequired
        isInvalid={showErrors && Boolean(errors.amount)}
        isDisabled={isDisabled || isAmountDisabled}
      >
        <FormLabel>Amount</FormLabel>
        <NumberInput
          min={0.01}
          precision={2}
          value={amount}
          onChange={onAmountChange}
          isDisabled={isDisabled || isAmountDisabled}
        >
          <NumberInputField placeholder='0.00' />
        </NumberInput>
        <FormErrorMessage>{errors.amount}</FormErrorMessage>
      </FormControl>

      <FormControl
        isRequired
        isInvalid={showErrors && Boolean(errors.startDate)}
        isDisabled={isDisabled}
      >
        <FormLabel>Start date</FormLabel>
        <Input
          type='date'
          value={startDate}
          onChange={(event) => onStartDateChange(event.target.value)}
        />
        <FormErrorMessage>{errors.startDate}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={showErrors && Boolean(errors.endDate)} isDisabled={isDisabled}>
        <FormLabel>End date</FormLabel>
        <Input
          type='date'
          value={endDate}
          onChange={(event) => onEndDateChange(event.target.value)}
        />
        {errors.endDate ? (
          <FormErrorMessage>{errors.endDate}</FormErrorMessage>
        ) : (
          <FormHelperText>Leave blank for ongoing add-ons.</FormHelperText>
        )}
      </FormControl>
    </Grid>
  )
}
